<span id="growl">
  <p-growl id="growlStick" [sticky]="true" [(value)]="msgsStick" ></p-growl>
  <p-growl id="growlNoStick" [sticky]="false" [(value)]="msgsNoStick"></p-growl>
</span>
